module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-org"
  }, [_c('ep-title', {
    attrs: {
      "title": "用户信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-form"
  }, [_c('div', {
    staticClass: "u-p"
  }, [_c('span', [_vm._v("登录账号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.statelist.username))])]), _vm._v(" "), _c('div', {
    staticClass: "u-p"
  }, [(_vm.show_emily) ? _c('p', {
    staticClass: "u-emile"
  }, [_c('span', [_vm._v("邮箱")]), _vm._v(" "), _c('span', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(_vm.statelist.email))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-edit",
    on: {
      "click": _vm.change_emily
    }
  }, [_vm._v(_vm._s(_vm.changeVal(_vm.statelist.email)))])]) : _c('p', {
    staticClass: "u-emile"
  }, [_c('span', [_vm._v("邮箱")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.mod_emily),
      callback: function($$v) {
        _vm.mod_emily = $$v
      },
      expression: "mod_emily"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sub_emily
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.close_emily
    }
  }, [_vm._v("取消")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "u-p"
  }, [(_vm.show_name) ? _c('p', {
    staticClass: "u-name"
  }, [_c('span', [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(_vm.statelist.name))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-edit",
    on: {
      "click": _vm.change_name
    }
  }, [_vm._v(_vm._s(_vm.changeVal(_vm.statelist.name)))])]) : _c('p', {
    staticClass: "u-emile"
  }, [_c('span', [_vm._v("姓名")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.mod_name),
      callback: function($$v) {
        _vm.mod_name = $$v
      },
      expression: "mod_name"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sub_name
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.close_name
    }
  }, [_vm._v("取消")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "u-p"
  }, [(_vm.show_job) ? _c('p', {
    staticClass: "u-name"
  }, [_c('span', [_vm._v("职位")]), _vm._v(" "), _c('span', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(_vm.statelist.duty))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-edit",
    on: {
      "click": _vm.change_job
    }
  }, [_vm._v(_vm._s(_vm.changeVal(_vm.statelist.duty)))])]) : _c('p', {
    staticClass: "u-emile"
  }, [_c('span', [_vm._v("职位")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.mod_job),
      callback: function($$v) {
        _vm.mod_job = $$v
      },
      expression: "mod_job"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sub_job
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.close_job
    }
  }, [_vm._v("取消")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "u-p"
  }, [(_vm.show_pwd) ? _c('p', {
    staticClass: "u-name"
  }, [_c('span', [_vm._v("登录密码")]), _vm._v(" "), _c('span', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v("建议您定期更换密码，设置的密码长度为8-20个字符，且至少包含1个大写字母，1个小写字母和1个数字，其他可以是任意字符")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-edit",
    on: {
      "click": _vm.change_pwd
    }
  }, [_vm._v("修改")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "u-p"
  }, [_c('span', [_vm._v("微信")]), _vm._v(" "), (_vm.hasWechat) ? _c('span', [_vm._v("\n                    " + _vm._s(this.statelist.wechatNickName) + " \n                    "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.unBindWechat
    }
  }, [_vm._v("解除绑定")])], 1) : _c('span', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.bindWechat
    }
  }, [_vm._v("绑定")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "u-p"
  }, [_c('p', {
    staticClass: "u-name"
  }, [_c('span', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeCompany
    }
  }, [_vm._v("切换单位")])], 1)])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "切换申报单位",
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-box",
    staticStyle: {
      "height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('ul', {
    staticClass: "content-con"
  }, _vm._l((_vm.detail), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.liclick(item, index)
        }
      }
    }, [_c('a', {
      class: {
        active: _vm.selectIndex === index
      }
    }, [_vm._v(_vm._s(item.value))])])
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeSure
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "绑定微信",
      "visible": _vm.showQrCode,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showQrCode = $event
      }
    }
  }, [_c('span', [_vm._v("绑定微信后，可实时收到备案事项提醒消息，以及系统更新公告等内容推送。\n                    请尽快用微信扫码绑定您的账号。")]), _vm._v(" "), _c('img', {
    staticClass: "qr-img",
    attrs: {
      "src": _vm.qrCodeUrl
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d767ade","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/account/User.vue
// module id = 1256
// module chunks = 2